	import React from 'react'
import Collapse from '@material-ui/core/Collapse'

import BkFlowEditPromoField from './BkFlowEditPromoField'
import BkFlowEditRateField from './BkFlowEditRateField'

import yn from 'yn'

import '../../../styles/css/components/edit/bk-flow-edit-stay-rates.css'

const BkFlowEditRatesAccordion = props => {
	const {
		ratesExpanded,
		currentPromoCode,
		handlePromoCode,
		currentRateCode,
		handleRateCode,
		hotelLabels,
		specialCodeError,
		isSpecialCodeAvailable
	} = props

	return (
		<Collapse
			className="bk-flow-edit-stay__rates-accordion"
			in={ ratesExpanded }
			timeout={ 300 }
		>
			<BkFlowEditPromoField
				currentPromoCode={currentPromoCode}
				handlePromoCode={handlePromoCode}
				hotelLabels={hotelLabels}
				specialCodeError={specialCodeError}
				isSpecialCodeAvailable={isSpecialCodeAvailable}
			/>

			<BkFlowEditRateField
				currentRateCode={currentRateCode}
				handleRateCode={handleRateCode}
				hotelLabels={hotelLabels}
				specialCodeError={specialCodeError}
			/>

			{ yn(process.env.REACT_APP_COMPONENT_EDIT_STAY_PROMO_CODE_AVAILABILITY) && specialCodeError && !isSpecialCodeAvailable &&
				<p className="bk-flow-edit-stay__rates-accordion-error u-error u-font-xs u-txt-center">Invalid code - please try again.</p>
			}
		</Collapse>
	)
}


export default BkFlowEditRatesAccordion


// WEBPACK FOOTER //
// ./src/components/edit/rates/BkFlowEditRatesAccordion.js